//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uniRate from "@/components/uni-rate/uni-rate.vue"
import moment from 'dayjs'
import uParse from '@/components/gaoyia-parse/parse.vue'
import calendarPage from '@/components/calendarPage/calendarpage.vue'
import collect from '@/components/collect/index.vue'
import commentList from '@/components/commentList/index.vue'
import uniIcons from "@/components/uni-icon/uni-icon.vue"
export default {
    data(){
        return{
            id:'',
            detail:{
                haveFacils: [], //设备
            },
            collectInfo:{
                collectionType:'30',
                productGroupType:'2002',
                collectionId:''
            },
            setMeal: [],//住房
            cashCoupon: [],//优惠券
            moreShow: false,
            roomList: [],
            memberId:'',
            //顶部轮播图
            imgList:[],
            autoplay: true,
            interval: 2000,
            circular:true, //是否采用衔接滑动
            duration: 500,
            current:1, //当前所在滑块
            currentLength:0, //图片总数
            //日历
            IsCalender: false,
            close:false,
            info: {
                checkInDate: '2018-6-23',
                checkOutDate: '2018-6-26'
            },
            roomForm: {
                beginTime: '2018-6-23',
                endTime: '2018-6-24',
                bodyId: ''
            },
			isWeixin:true,
            detailAddress:'',
            commentObj: {
				total: 0,
				starLevel: 5
			}
        }
    },
    components:{uniRate,calendarPage,uParse,collect,commentList,uniIcons},
    computed: {
        total () {  //住宿天数
            var date1 = new Date(this.info.checkInDate.replace(/-/gm, '/'))
            var date2 = new Date(this.info.checkOutDate.replace(/-/gm, '/'))
            return parseInt((date2 - date1) / (24 * 60 * 60 * 1000))
        },
        openTime () {   //开业年份
            return this.detail.openBusinessTime ? new Date(this.detail.openBusinessTime).getFullYear() + '年开业' : ''
        },
        devicesTitle () {   //设备展示
            return this.moreShow ? '收起更多设备' : '查看更多设备'
        },
        showDevices () {    //设备展示
            if (!this.moreShow && this.detail.haveFacils.length > 4) {
                return this.detail.haveFacils.slice(0, 4)
            } else {
                return this.detail.haveFacils
            }
        },
    },
    onLoad(event) {
        this.collectInfo.collectionId = this.id = event.id





    },
	onShow(){
		this.initDate()
        this.getDetail()
        // this.queryCommentList()
	},
    methods:{
        previewImage (url) {
            window.wx.previewImage({
                current: url, // 当前显示图片的http链接
                urls: [url] // 需要预览的图片http链接列表
            })
        },
        jump(){
            uni.navigateTo({
                url:'/pages/common/images?image='+this.imgList
            })
        },
        handleLink (item) {
            let id = item.productId
            let inDate = moment(new Date(this.info.checkInDate.replace(/-/gm, '/'))).format('YYYY-MM-DD')
            let outDate = moment(new Date(this.info.checkOutDate.replace(/-/gm, '/'))).format('YYYY-MM-DD')
            uni.navigateTo({
                url:`/pages/hotel/order?productId=${id}&inDate=${inDate}&outDate=${outDate}&total=${this.total}&bodyId=${this.id}`
            })
        },
        changeImg(event){
            this.current=event.detail.current+1
        },
        async initDate () {
            let date = new Date()
            let hours = date.getHours()
            if (hours < 20) {
                this.info.checkInDate = moment(date).format('YYYY-M-D')// moment(date).format('YYYY-M-D')
                date.setDate(date.getDate() + 1)
                this.info.checkOutDate = moment(date).format('YYYY-M-D')// moment(date).format('YYYY-M-D')
            } else {
                date.setDate(date.getDate() + 1)
                this.info.checkInDate = moment(date).format('YYYY-M-D')// format(date, 'YYYY-M-D')// moment(date).format('YYYY-M-D')
                date.setDate(date.getDate() + 1)
                this.info.checkOutDate = moment(date).format('YYYY-M-D') // format(dates, 'YYYY-M-D')// moment(date).format('YYYY-M-D')
            }
            this.gethotelRoom()
        },
        // 弹出日历弹框
        handleTimeClick () {
            this.close = false
            this.IsCalender = true
        },
        dateFormat (date) {
            let dateArray = date.split('-')
            let month = parseInt(dateArray[1]) < 10 ? '0' + dateArray[1] : dateArray[1]
            let day = parseInt(dateArray[2]) < 10 ? '0' + dateArray[2] : dateArray[2]
            return dateArray[0] + '-' + month + '-' + day
        },
        async gethotelRoom () {
            let _this = this
            _this.roomForm.beginTime = _this.dateFormat(_this.info.checkInDate)
            _this.roomForm.endTime = _this.dateFormat(_this.info.checkOutDate)
            _this.roomForm.bodyId = _this.id
            this.$ajax({
                method: 'post',
                url: '/weChat/hotelbody/queryProductList',
                isForms: true,
                data: _this.roomForm
            }).then(res=>{
               _this.roomList = res.data
                _this.roomList.forEach(t => {
                    t.name = t.name.length > 12 ? t.name.substr(0, 12) + '...' : t.name
                    let square = t.square ? '/' + t.square + 'm²' : ''
                    let info = (t.isContainBreakfast === 1 ? '含早' : '不含早') + square
                    info = t.bedType + '/' + info
                    t['info'] = info.length > 14 ? info.substr(0, 14) + '...' : info
                }) 
            })
        },
        getDetail(){
            let _this=this
            this.$ajax({
                method: 'POST',
                url: '/weChat/hotelbody/queryById',
                data: {
                    bodyId: this.id,
                    beginTime: moment().format('YYYY-MM-DD'),
                    endTime: moment().add(1, 'day').format('YYYY-MM-DD')
                }
            }).then(res=>{
                _this.detail=res.data				
                _this.detail.address = res.data.provinceName + '  ' + res.data.cityName + '  ' +res.data.districtName + ' 详细地址:' + res.data.detailAddress
                _this.imgList=res.data.images.split(',')
                _this.currentLength=_this.imgList.length
                _this.detail.addressAdvantage = _this.detail.addressAdvantage.length>=21?_this.detail.addressAdvantage.substr(0, 21)+'...':_this.detail.addressAdvantage
                _this.$nextTick(()=>{
                    _this.detailAddress = _this.detail.detailAddress
                })



                res.data.list.map((t) => {
                    t.validStartDate = t.validStartDate ? moment(t.validStartDate).format('M月DD日') : ''
                    t.validEndDate = t.validEndDate ? moment(t.validEndDate).format('M月DD日') : ''
                    t.effectTime = t.effectTime ? moment(t.effectTime).format('M月DD日') : ''
                    t.effectEndTime = t.effectEndTime ? moment(t.effectEndTime).format('M月DD日') : ''
                    if (t.foodType === 2) {
                        _this.setMeal.push(t)
                    } else if (t.foodType === 1) {
                        _this.cashCoupon.push(t)
                    }
                })
            })
        },
        handeldetermine (date) {
            this.info = date
            this.gethotelRoom()
            this.close = true
            setTimeout(()=>{							
                this.IsCalender = false
            },300)
        },
        // 日历关闭
        handelClose () {
            this.close = true
            setTimeout(()=>{							
				this.IsCalender = false
			},300)
        },
        tel(phone){
            uni.makePhoneCall({
                phoneNumber: phone
            })
        },
        showPosition(){
            if (this.detail.latitude && this.detail.longitude) {















            }
        },
        updateComments(data) {
			this.commentObj.total = data.count
			this.commentObj.starLevel = parseFloat(data.dataObj || 0)
		}
    }
}
